import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, LifeBuoy, Mail } from 'lucide-react';
import Header from '../components/Header';
import MobileNav from '../components/MobileNav';
import { apiFetch } from '../lib/apiClient';

export default function Help() {
  const [support, setSupport] = useState({
    support_email: 'support@skipdq.me',
    vendor_support_email: 'vendors@skipdq.ca',
  });

  useEffect(() => {
    const loadSupport = async () => {
      try {
        const res = await apiFetch('/api/support-settings');
        if (res.ok) {
          setSupport(await res.json());
        }
      } catch (e) {
        // keep defaults if request fails
      }
    };
    loadSupport();
  }, []);

  return (
    <div className="min-h-screen bg-background pb-safe">
      <Header />
      <div className="max-w-3xl mx-auto px-4 pt-20 pb-24">
        <Link to="/" className="inline-flex items-center gap-2 text-muted-foreground hover:text-foreground mb-6">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>
        <div className="bg-card border rounded-2xl p-6 sm:p-8">
          <div className="flex items-center gap-2 mb-4">
            <LifeBuoy className="w-5 h-5 text-primary" />
            <h1 className="text-2xl font-bold">Help & Support</h1>
          </div>
          <p className="text-sm text-muted-foreground mb-6">
            Need help with an order, refund, vendor issue, or account? Email us and we will respond ASAP.
          </p>

          <div className="space-y-4">
            <a
              href={`mailto:${support.support_email}`}
              className="flex items-center justify-between border rounded-xl p-4 hover:bg-muted/40"
            >
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary" />
                <div>
                  <p className="font-medium">Student Support</p>
                  <p className="text-sm text-muted-foreground">{support.support_email}</p>
                </div>
              </div>
              <span className="text-xs text-muted-foreground">Email</span>
            </a>

            <a
              href={`mailto:${support.vendor_support_email}`}
              className="flex items-center justify-between border rounded-xl p-4 hover:bg-muted/40"
            >
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-primary" />
                <div>
                  <p className="font-medium">Vendor Support</p>
                  <p className="text-sm text-muted-foreground">{support.vendor_support_email}</p>
                </div>
              </div>
              <span className="text-xs text-muted-foreground">Email</span>
            </a>

            <div className="pt-2 flex flex-wrap gap-4 text-sm">
              <Link to="/privacy-policy" className="text-primary hover:underline">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-primary hover:underline">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
      <MobileNav />
    </div>
  );
}
